"use client"
import React, { useEffect, useState } from 'react'
import DramaList from '../component/DramaList';
import watch from "../watchnow/watch.module.css"
import { useFavoriteStore } from '../store/localapi';
import InFeedAd from '../component/ad/InFeedAd';

export default function Savelist() {
  const favorites = useFavoriteStore((state) => state.favorites);
  const [favoriteDramas, setFavoriteDramas] = useState<any[]>([]); // eslint-disable-line @typescript-eslint/no-explicit-any

  useEffect(() => {
    // eslint-disable
    const dramas = Object.values(favorites) 
      .sort((a: any, b: any) => { // eslint-disable-line @typescript-eslint/no-explicit-any
        const at = a.createdAt || new Date(a.mobile_dt || 0).getTime() || 0; 
        const bt = b.createdAt || new Date(b.mobile_dt || 0).getTime() || 0;
        return bt - at; // newer first
      })
      .map(fav => ({
        ...fav,
        d_name: fav.d_title,
        total_d_stream: fav.total_ep
      }));
    setFavoriteDramas(dramas);
  }, [favorites]);

  return (
    <>
        <div className={watch.watchNow}>
          <h2>My List</h2>
        </div>

        <div className={watch.watchDramasBg}>
          <div className="container">
            <InFeedAd style={{ margin: '20px 0' }} />
           <DramaList dramas={favoriteDramas} allEp={true} fav={true} />
           </div>
        </div>
   </>
  )
}
